import { containerNarrow } from '@/lib/ds';
import { useLanguage } from '@/components/utils/useLanguage';

export default function ActivityIntro({ activity }) {
  const { getField } = useLanguage();

  return (
    <section className={`${containerNarrow} py-16`}>
      <div className="text-xl sm:text-2xl md:text-3xl text-center text-gray-700 space-y-3">
        {getField(activity, 'intro').split('\n').map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
    </section>
  );
}